import React, { useContext } from 'react'
import Recommendations from '../../components/Agent/Home/Recommendations'
import Summary from '../../components/Agent/Home/Summary'
import SingleSelect from '../../components/Common/DropDown/SingleSelect'
import { AuthContext } from '../../store/auth-context'
import styles from '../../styles/agent/Home.module.css'


const AgentHome = () => {

    const authCtx = useContext(AuthContext)

    return (
        <div className="container bodyContainer">
            <div className="d-flex justify-content-between align-items-baseline">
                <h1 className={`page-heading page-header ${styles.pageHeader}`}>Good morning, <b>{authCtx.firstName}!</b></h1>
                <SingleSelect options={['Last 30 days', 'Last 6 months', 'Last 1 year']} />
            </div>
            <div className={`row ${styles.container}`}>
                <div className="col-8">
                    <Summary />
                </div>
                <div className="col-4">
                    <Recommendations />
                </div>
            </div>
        </div>
    )
}

export default AgentHome
